<template>
  <div>
    <portlet
        :icon="'fad fa-file'"
        :title="'Import'"
        :actions-block="true"
        :fullheight="true"
        :footer="true"
        class="portlet-pt-20 "
    >
      <template slot="actionsBlock">
        <button class='btn btn-secondary  '
                @click="$router.go(-1)">
          <i class="fas fa-long-arrow-left mr-2"></i>
          {{ $t('ui.back') }}
        </button>

      </template>
      <template slot="portletBody">
        <div class="row">
          <div class="col-12"><h3>General settings</h3></div>
          <div class="col-4">
            <label for="">Name your import</label>
            <input type="text" v-model="importName" class="form-control" placeholder=" "
                   aria-label="Recipient's username" aria-describedby="basic-addon2">

          </div>
          <div class="col-8">
            <label for="">Email address where file is sent too</label>
            <div class="input-group mb-3">
              <input type="text" v-model="emailPrefix" class="form-control" placeholder=" "
                     aria-label="Recipient's username" aria-describedby="basic-addon2">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon2">{{ email }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <label>Choose file</label>
            <!--            <input type="file" @change="handleFileChange"/>-->
            <VueFileAgent
                ref="vueFileAgent"
                :theme="'list'"
                :multiple="false"
                :deletable="true"
                :meta="true"
                :maxSize="10000000"
                :maxFiles="1 "
                :helpText="$t('import.fileUpload.text')"
                @select="handleFileChange($event)"
                @beforedelete="onBeforeDelete($event)"
                @delete="fileDeleted($event)"
                v-model="fileRecords"
            ></VueFileAgent>
            <!--            -->
          </div>
          <div class="col-4" v-if="fileRecords">
            <label for="">Select excel workbook</label>
            <select name="workbook" class="form-control" v-model="selectedSheet" id="">
              <option :value="null" v-show="!excel.workbook" disabled>Choose file first..</option>
              <option :key="sheetName" v-for="sheetName in excel.sheetNames" :value="sheetName">{{ sheetName }}</option>
            </select>
          </div>
          <!--          <div class="col-3">-->
          <!--            <label for="">Includea</label>-->
          <!--            <select name="workbook" class="form-control" v-model="selectedSheet" id="">-->
          <!--              <option :value="null" v-show="!excel.workbook" disabled>Choose file first..</option>-->
          <!--              <option :key="sheetName" v-for="sheetName in excel.sheetNames" :value="sheetName">{{ sheetName }}</option>-->
          <!--            </select>-->
          <!--          </div>-->
        </div>
        <hr>

        <div class="row" v-if="selectedSheet">
          <div class="col">
            <div class="row">
              <div class="col">
                <h3>Bind fields from import file to PMT</h3>
              </div>
            </div>

            <div :key=key class="row my-2" v-for="(pmtKey,key,index) in PMTMapping">
              <div class="col-2">

                <input type="text" class="form-control" :class="PMTMapping[key].required ? 'required' :' '" disabled
                       :value="key"/>
              </div>

              <div class="col-2">
                <select name="" id="" class="form-control" v-model="PMTMapping[key].value">
                  <option :value="null"></option>

                  <template v-for="col in getColumns">
                    <option :key="col" :value="col"> {{ col }}</option>
                  </template>
                </select>
              </div>
              <div class="col-2">
                <input type="text" class="form-control" v-show="PMTMapping[key].format"
                       v-model="PMTMapping[key].format">

                <select v-show="PMTMapping[key].timeUnit !== undefined" name="" class="form-control"
                        v-model="PMTMapping[key].timeUnit" id="">
                  <option :key="unit" v-for="unit in timeUnits" :value="unit">{{ unit }}</option>
                </select>
              </div>
              <div class="col-2" style="border-right:2px solid #e0e0e0;">
                <select v-show="PMTMapping[key].timezone" name="" class="form-control"
                        v-model="PMTMapping[key].timezone" id="">
                  <option :key="tz" v-for="tz in timeZoneList " :value="tz">{{ tz }}</option>
                </select>

              </div>

              <div class="col-3">
                <p class="data-preview">
                  {{ getParsedValue(key, PMTMapping[key]) }}
                </p>
              </div>
            </div>
            <div class="row" height="20px" :key="index+'custom'" v-for="(customField,index) in customFields">
              <div class="col-2">
                <label for="">customField {{ index + 1 }}</label>
                <input type="text" class=form-control v-model="customField.fieldName">
              </div>

              <div class="col-2">
                <label for="">Link to import file</label>
                <select name="" id="" class="form-control" v-model="customField.value">
                  <option :value="null"></option>
                  <template v-for="col in getColumns">
                    <option :key="col" :value="col"> {{ col }}</option>
                  </template>
                </select>
              </div>
              <div class="col-2">
                <label for="">Type data</label>
                <select name="" id="" v-model="customField.type" class=form-control>
                  <option value="string">string</option>
                  <option value="integer">Number</option>
                  <option value="float">Decimal</option>
                  <!--                  <option value="date">date</option>-->
                </select>
              </div>
              <div class="col-2">
                <!--                <template v-show="customField.type == 'date'">-->
                <!--                  <label for="">format</label>-->
                <!--                  <input type="text" class="form-control"-->
                <!--                         v-model="customField.format">-->
                <!--                </template>-->
              </div>
              <!--              <div class="col-2">-->
              <!--                <template v-show="customField.type =='date'">-->
              <!--                  <label for="">tz</label>-->
              <!--                  <select   name="" class="form-control"-->
              <!--                          v-model="customField.timezone" id="">-->
              <!--                    <option :key="tz" v-for="tz in timeZoneList " :value="tz">{{ tz }}</option>-->
              <!--                  </select>-->
              <!--                </template>-->
              <!--              </div>-->
              <div class="col-3">
                <label for="">&nbsp;</label>
                <p class="data-preview">

                  {{ getParsedValue(customField.fieldName, getPMTMapping[customField.fieldName]) }}
                </p>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col">
                <button class="btn btn-outline-filter" @click="addCustomField()">Add a custom field</button>
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="preview">
              <div class="controls text-center center-align align-center">
                <button class="btn float-left" @click="iterator--" :disabled="iterator >=1 ? false : true"><i
                    class="fas fa-chevron-left"></i></button>
                <h3 style="display:inline">{{ iterator + 1 }} / {{ getRowsFromExcel.length }}</h3>
                <button class="btn float-right"
                        @click="iterator++"
                        :disabled="iterator < (getRowsFromExcel   ? getRowsFromExcel.length-1 : 100) ? false : true"><i
                    class="fas fa-chevron-right"></i>
                </button>
              </div>
              <div class="data">
                <table class="table table-striped" v-if="selectedSheet">
                  <thead>
                  <th>column</th>
                  <th>value</th>
                  </thead>
                  <tbody>
                  <tr :key=key v-for="(row,key) in getRowData">
                    <td><strong>{{ key }}</strong></td>
                    <td>
                      {{ row }}
                    </td>
                  </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>

          <div class="col-12">


          </div>
        </div>

        <div class="row" v-else>
          <div class="col"><h3>No file selected </h3></div>
        </div>

      </template>
      <template slot="portletFooter" v-if="selectedSheet">
        <div class="col-12">
        <button class="btn btn-success " @click="saveMapping">Save Mapping</button>
        </div>
      </template>
    </portlet>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
 import general from '@/mixins/importMapping/general'
export default {
  name: "ImportIndex",
  mixins:[general],
  components: {},
  data() {
    return {
      fileRecords: null,
      iterator: 0,
      email: '',
      emailPrefix: '',
      importName: '',
      selectedSheet: null,
      timeUnits: ['hour', 'minute', 'second', 'millisecond'],
      PMTMapping: {
        orderNumber: {value: null, type: 'string', required: true},
        uid: {value: null, type: 'string', required: true},
        activity: {value: null, type: 'string', required: true},
        plannedDate: {
          value: null,
          type: 'date',
          format: 'DD-MM-YYYY HH:mm:ss',
          timezone: 'Europe/Amsterdam',
          required: true
        },
        amount: {value: null, type: 'integer', required: true},
        target: {value: null, type: 'float', timeUnit: 'hour', required: true},
        productNumber: {value: null, type: 'string'},
        productDescription: {value: null, type: 'string'},
        npc: {value: null, type: 'integer', timeUnit: 'hour'},
        allowedWorkflowIds: {value: [], type: 'string'},
        department: {value: null, type: 'string'},

      },
      customFields: [],
      excel: {
        workbook: null,
        sheetNames: [],
        sheets: [],
      }
    }
  },
  computed: {
    ...mapGetters('company', ['getCompanyName']),
    ...mapGetters('users', ['getClaims']),

  },
  methods: {
    saveMapping() {
      let companyId = this.getClaims.companyId
      this.$FB.collection('importMappings').add({
        companyId,
        type: 'email',
        importName: this.importName,
        email: this.emailPrefix + this.email,
        mapping: this.PMTMapping,
        sheet: this.selectedSheet
      }).then(() => {
        this.swalToastSuccess('Saved')
      }).catch(e => {
        this.swalError(e.message)
      })
    }
  },
  created() {
    this.email = this.getRandomHash
  }

}
</script>

<style scoped>
input.required {
  font-weight: 700;
}

.input-group-text {
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1.5rem;
  width: 100%;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}

.data-preview {
  display: flex;
  margin-top: 5px;
  font-size: 15px;
}
</style>